﻿import $ from "jquery";
import * as FormHelper from "../utils/formHelper"

const newsletterSubscribeSection = $(".js--newsletter-subscribe-section");
const newsletterEditSection = $(".js--newsletter-edit-section");
const emailerrorbox = newsletterSubscribeSection.find(".email__section");
const emailconsentsbox = newsletterSubscribeSection.find(".subscriber-emailconsents-box");

let unsubscribe = () => {
    const unsubscribeSuccessPage = $(newsletterEditSection).find(".unsubscribe-button").attr("href");
    const email = newsletterEditSection.find(".subscriber-email").val();
    $.ajax({
        type: "post",
        url: "/api/NewsletterApi/Unsubscribe",
        data: {
            email: email
        },
        success: function () {
            window.location.href = `${unsubscribeSuccessPage}`;
        },
        error: function () {
            $("#errorMessage").show();
            $(emailerrorbox).addClass("is-invalid");
        }
    });
};

let saveChanges = () => {
    const linkToRedirect = $(newsletterEditSection).find(".submit-button").attr("href");
    const subscriptionListsIds =
        FormHelper.GetDataAttributesArray(newsletterEditSection, ".subscription-list", "subscription-list");
    const categoriesIds = FormHelper.GetValuesArray(newsletterEditSection, ".newsletter-category:checked");
    const email = newsletterEditSection.find(".subscriber-email").val();

    const previousEmail = $("#previousEmail").val();
    if (email) {
        $.ajax({
            type: "post",
            url: "/api/NewsletterApi/Edit",
            data: {
                subscriptionListsIds: subscriptionListsIds,
                categoriesIds: categoriesIds,
                email: email,
                previousEmail: previousEmail
            },
            success: function () {
                window.location.href = `${linkToRedirect}`;
            },
            error: function () {
                $("#errorMessage").show();
                $(emailerrorbox).addClass("is-invalid");
            }
        });
    }
}


$(".js--newsletter-edit-section").on("click",
    ".submit-button",
    function (e) {
        e.preventDefault();
        $(emailconsentsbox).css("border", "none");
        $(emailerrorbox).removeClass("is-invalid");
        $("#errorMessage").hide();
        saveChanges();

    });

$(".js--newsletter-edit-section").on("click",
    ".unsubscribe-button",
    function (e) {
        e.preventDefault();
        $(emailerrorbox).removeClass("is-invalid");
        $("#errorMessage").hide();
        unsubscribe();
    });


//////////////////
// WEBPACK FOOTER
// ./Scripts/newsletter/newsletterEdit.js
// module id = 10
// module chunks = 1